document.addEventListener('DOMContentLoaded', function() {
  try {
    console.log('DOM fully loaded and parsed.');

    // Get the current screen width
    const screenWidth = window.innerWidth;

    // 1st Script: For Desktop (screen width greater than 1024px)
    if (screenWidth > 1024) {
      const flexContainer = document.querySelector('.testimonials-container');

      if (flexContainer) {
        let hoveredCard = null; // Store the currently hovered card

        // Event delegation: Add event listener to the flex-container for mouseover and mouseout
        flexContainer.addEventListener('mouseover', (event) => {
          const card = event.target.closest('.card');
          if (!card || card === hoveredCard) return; // Exit if no card is hovered or it's the same card
          
          // Set the new hovered card
          hoveredCard = card;

          // Add the 'card-hovered' class to the hovered card
          card.classList.add('card-hovered');

          // Dim all other cards except the hovered one
          flexContainer.querySelectorAll('.card').forEach(otherCard => {
            if (otherCard !== card) {
              otherCard.classList.add('dimmed');
            }
          });

          // Add the 'dimmed' class to the container
          flexContainer.classList.add('dimmed');
        });

        flexContainer.addEventListener('mouseout', (event) => {
          const card = event.target.closest('.card');
          if (!card || card !== hoveredCard) return; // Exit if it's not the hovered card
          
          // Remove the 'card-hovered' class
          card.classList.remove('card-hovered');

          // Remove dimming from all cards
          flexContainer.querySelectorAll('.card').forEach(otherCard => {
            otherCard.classList.remove('dimmed');
          });

          // Remove the 'dimmed' class from the container
          flexContainer.classList.remove('dimmed');

          // Reset the hovered card
          hoveredCard = null;
        });
      } else {
        console.warn('Desktop: testimonials-container not found.');
      }
    }

    // 2nd Script: For Mobile Only (screen width less than 768px)
    if (screenWidth < 768) {
      const cards = document.querySelectorAll('.testimonials-container .card');

      if (cards.length > 0) {

        // Add event listener for scroll event
        window.addEventListener('scroll', () => {
          const screenMidpoint = window.innerHeight / 2; // Middle of the screen

          let closestCard = null;
          let closestDistance = Infinity;

          cards.forEach((card) => {
            const cardRect = card.getBoundingClientRect();
            const cardMidpoint = cardRect.top + cardRect.height / 2;

            // Calculate the distance between the card's midpoint and the screen's midpoint
            const distanceToCursor = Math.abs(cardMidpoint - screenMidpoint);

            // Check which card is closer to the middle of the screen
            if (distanceToCursor < closestDistance) {
              closestCard = card;
              closestDistance = distanceToCursor;
            }
          });

          // Remove the 'card-hovered' class from all cards
          cards.forEach(card => card.classList.remove('card-hovered'));

          // Add the 'card-hovered' class to the closest card
          if (closestCard) {
            closestCard.classList.add('card-hovered');
          }
        });
      } else {
        console.warn('Mobile: No cards found.');
      }
    }
  } catch (error) {
    console.error('Error detected in the script:', error);
  }
});
